<template>
    <div class="search-control" :style="mainStyles">
        <UiInput size="large" v-model="keyword" v-bind="inputAttrs" v-on="inputOns" />
        <div class="search-control-button" @click="$emit('search')">
            <UiIcon name="search" class="search-control-icon" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { UiInput, UiIcon } from "various-ui";
import { ToolSearchPropsOption } from "./index";
import { useComposable } from "./src/composable";

const define = defineProps(ToolSearchPropsOption);
const emit = defineEmits<{
    (event: "search"): void;
    (event: "update:modelValue", keyword: string): void;
}>();

const { refs, methods, computeds } = useComposable(define, emit);

const { keyword } = refs;
const { mainStyles, inputAttrs, inputOns } = computeds;

defineExpose({ init: methods.init });
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
